import { CLEAR_ERROR } from '@store/action-types/user';

const clearError = () => ({ type: CLEAR_ERROR });

export default clearError;
